import t from 'l10n';

export const AUTH_TOKEN = 'accessToken';

export const clearSession = redirectPath => {
  sessionStorage.removeItem(AUTH_TOKEN);
  window.location.href = redirectPath;
};

export function commonErrorHandler(response) {
  if (response && response.ok) {
    return response;
  }

  if (response && response.status === 401) {
    clearSession('/login');
    alert(t('login.expire'));
  }

  throw new UserException('Request failure', response.status);
}

function UserException(message, status) {
  this.message = message;
  this.status = status;
}
